import React, { useState } from "react";
import { BackButton } from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, { TwoNEW } from "../../../../Components/Utils/Select";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import UseDropDownPR from "../../../../Components/Hooks/UserddNewPr";
function CreateCustomerQuotes() {
  const location = useLocation();
  let pathFile = location.pathname;

  const [search, setSearch] = useState("");

  // const { data: PR } = UseDropDown('/PR/drop-down');
  const { data: PR, originalData } = UseDropDownPR(
    `/customer-quotations/PR-drop-down?search=${search}`,
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { prId: "" },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => { },
  });
  const selectedPR = originalData.find(
    (item) => item.id === formik.values.prId,
  );
  const isRevised = selectedPR?.isRevised;
  console.log(isRevised, "isRevised");

  return (
    <div className="w-full h-full py-2 px-2 lg:px-4 ">
      <div className="flex justify-between ">
        <Breadcrumb
          items={[
            // { name: "Sales",
            // link: "/sales/quotes" },
            {
              name: "Customer Quotation",
              link: "/sales/quotes",
            },
            {
              name: "Create Customer Quotation",
            },
          ]}
        />
        <BackButton />
      </div>
      <div className="flex flex-col md:flex-row gap-2 items-start  w-full">
        <TwoNEW
          label="YPR"
          placeholder="Choose"
          Options={PR}
          formik={formik}
          name="prId"
          setSearch={setSearch}
          FixPosition={false}
          PortalTarget={false}
          width="w-full md:w-1/2 lg:w-1/3"
        />
        {isRevised && (
          <div className="mt-12 flex items-center gap-2">
            <span className="inline-block rounded-full bg-yellow-100 px-3 py-1 text-xs font-semibold text-yellow-800 shadow">
              🔁 Revised
            </span>
          </div>
        )}
      </div>
      <div className=" w-full h-8 flex items-center px-1 ">
        <>
          <Link
            to={`/sales/quotes/create`}
            state={{ data: { prId: formik.values.prId, isRevised: isRevised } }}
            className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${`/sales/quotes/create` == pathFile
                ? "border-b-2 border-baseColor-primary"
                : "border-b-2 border-transparent"
              }   `}
          >
            {"Create Quote"}
          </Link>
        </>
        <>
          <Link
            to={`/sales/quotes/create/viewqoutes`}
            state={{ data: { prId: formik.values.prId, isRevised: isRevised } }}
            className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${`/sales/quotes/create/viewqoutes` == pathFile
                ? "border-b-2 border-baseColor-primary"
                : ""
              }   `}
          >
            {"Quote Comparison"}
          </Link>
        </>
      </div>
      <div className=" w-full h-[calc(100vh-250px)] ">
        {/* <Outlet context={{ prId: formik.values.prId }} /> */}
        <Outlet
          context={{
            prId: formik.values.prId,
            originalData,
            isRevised: isRevised,
          }}
        />
      </div>
    </div>
  );
}

export default CreateCustomerQuotes;
